import { LOCALE } from "../properties/Locale";

export const Enumerations = {
  AppEntryType: {
    TEMPORARY_TRAFFIC_CHANGE: "TEMPORARY_TRAFFIC_CHANGE",
    PERMANENT_TRAFFIC_CHANGE: "PERMANENT_TRAFFIC_CHANGE",
  },
  AppEntryTypeDisplay: {
    TEMPORARY_TRAFFIC_CHANGE: LOCALE.temporaryTrafficChange,
    PERMANENT_TRAFFIC_CHANGE: LOCALE.permanentTrafficChange,
  },
  AppEntryStatus: {
    NEW: "Ново",
    PENDING_PAYMENT: "Чека на уплата",
    SUBMITTED: "Поднесено за обработка",
    REJECTED: "Одбиено",
    PROCESSING: "Во обработка",
    CORRECTION: "Потребна е корекција",
    FOR_APPROVAL: "Генерирање барања за согласност",
    ADDITIONAL_CORRECTION: "Потребна е дополнителна корекција",
    INSTITUTIONS_REVIEW: "Барање согласност од институции",
    INSTITUTION_DECISION: "Одлука од институции",
    FINAL_DECISION_SIGNING: "Потпишување на конечна одлука",
    DONE: "Барањето е завршено",
    CANCELED: "Барањето е завршено",
  },
  AppReviewStatus: {
    PENDING: "На чекање",
    APPROVED: "Одобрено",
    REJECTED: "Одбиено",
  },
  DocumentType: {
    URBAN_PLANING_PROJECT_PDF: "Урбанистички проект PDF",
    URBAN_PLANING_PROJECT_DWG: "Урбанистички проект DWG",
    TRAFFIC_ENGINEERING_PROJECT_PDF: "Сообраќаен проект PDF",
    TRAFFIC_ENGINEERING_PROJECT_DWG: "Сообраќаен проект DWG",
    POWER_OF_ATTORNEY: "Полномошно овластување",
    PROOF_OF_PAYMENT: "Доказ за уплата",
    PROJECT_REVISION: "Ревизија",
    DECISION_MVR: "Одлука од МВР",
    DECISION_JPDP: "Одлука од ЈПДП",
    PERMANENT_TRAFFIC_CHANGE_REQUEST:
      "Барање за согласност за трајна измена на режим на сообраќај",
    TEMPORARY_TRAFFIC_CHANGE_REQUEST:
      "Барање за согласност за временска измена на режим на сообраќај",
    PERMANENT_TRAFFIC_CHANGE_REQUEST_SIGNED:
      "Потпишано барање за согласност за трајна измена на режим на сообраќај",
    TEMPORARY_TRAFFIC_CHANGE_REQUEST_SIGNED:
      "Потпишано барање за согласност за временска измена на режим на сообраќај",
  },
};
